import {
  Box,
  Container,
  SimpleGrid,
  Image,
  Heading,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";

// Import images
import FlowerIcon from "../../../assets/home/flower.png";
import FlowerIcon1 from "../../../assets/about/flowerpaaji.png";
import about16 from "../../../assets/about/portfolio/portfolio.png";
import about17 from "../../../assets/about/portfolio/portfolio1.png"; // Use this as the tilted image
import about171 from "../../../assets/about/aboutbuisness.png"; // Use this as the tilted image
import about18 from "../../../assets/about/portfolio/portfolio2.png";
import about19 from "../../../assets/about/portfolio/portfolio3.png";
import about20 from "../../../assets/about/portfolio/portfolio4.png";
import about21 from "../../../assets/about/portfolio/portfolio5.png";
import about22 from "../../../assets/about/portfolio/portfolio.png";
import about23 from "../../../assets/about/portfolio/portfolio.png";
import FlowerImage from "component/FlowerImage";
import cream from "../../../assets/flower/cream.png";
import blue from "../../../assets/flower/dark blue.png";
const portfolioImages = [
  about19,
  about20,
  about17,
  about21,
  about18,
  about16,
  about23,
  about22,
];

const Portfolio = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    onOpen();
  };

  return (
    <Box
      fontFamily={"Archivo"}
      bg="#0E121A"
      py={{ base: 32, md: 16 }}
      color="white"
      borderBottomRadius="3rem"
    >
      {/* Headline Section with Image */}
      <Container
        maxW="container.xl"
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        alignItems="center"
        justifyContent="space-between"
        textAlign={{ base: "center", md: "left" }}
        mb={10}
        gap={8}
      >
        {/* Left Text Section */}
        <Box
          width={{ base: "100%", md: "50%" }}
          display="flex"
          flexDirection="column"
          alignItems={{ base: "center", md: "flex-start" }}
          gap={4}
        >
          {/* Flower Icon */}
          <Image
            src={FlowerIcon}
            alt="Flower Icon"
            maxW="170px"
            display={{ base: "none", md: "block" }}
            className="fade-in-up"
          />

          {/* Headline */}
          <Box>
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="bold"
              color="white"
              lineHeight="1.2"
              mt={{ base: -16, md: -32 }}
              className="fade-in-up"
            >
              Where creativity meets{" "}
              <Text
                as="span"
                color="#BFA585"
                fontStyle="italic"
                className="fade-in-up"
              >
                results
              </Text>
            </Heading>
            <Text
              fontSize={{ base: "md", md: "xl", lg: "2xl" }}
              mt={2}
              fontStyle="italic"
              className="fade-in-up"
            >
              Crafting brands that{" "}
              <Text as="span" color="#BFA585" className="fade-in-up">
                conquer
              </Text>
              .
            </Text>
          </Box>

        </Box>

        {/* Right Image Section */}
        <Box
          width={{ base: "100%", md: "50%" }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={about171}
            alt="Creative Visual"
            borderRadius="lg"
            boxShadow="2xl"
            maxW={{ base: "40%", md: "50%" }}
            transform={{ base: "none", md: "rotate(5deg)" }}
            data-animated="true"
          />
        </Box>
      </Container>

      {/* Portfolio Grid */}
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={6}>
          {portfolioImages.map((image, idx) => (
            <Box
              key={idx}
              overflow="hidden"
              borderRadius="lg"
              boxShadow="lg"
              cursor="pointer"
              onClick={() => handleImageClick(image)}
            >
              <Image
                src={image}
                alt={`portfolio-${idx}`}
                width="100%"
                height="auto"
                borderRadius="md"
                className="image-zoom"
              />
            </Box>
          ))}
        </SimpleGrid>
      </Container>

      {/* Mantra Section */}
      <Container
        maxW="container.md"
        textAlign={{ base: "center", md: "center" }}
        mt={12}
        position="relative"
      >
        <Box
          as="div"
          fontSize="2xl"
          display="flex"
          justifyContent="center"
          color="white"
          mb={4}
          mx="auto"
          position="relative"
          my={8}
        >
          <Image
            src={FlowerIcon1}
            alt="Flower Icon"
            maxW="160px"
            position="absolute"
            top={-6}
            left={{ base: "32%", md: "40%" }}
            transform={{ base: "translateX(-50%)", md: "none" }}
            className="fade-in-up"
          />
          <Text as="span" color="#BFA585" my={8} className="fade-in-up">
            Our Mantra
          </Text>
        </Box>

        <Box my={12} maxW="container.md" mx="auto">
          <VStack>
            <Text
              as="span"
              fontSize={{ base: "lg", md: "xl" }}
              color="#FFFFFF"
              my={8}
              className="fade-in-up"
            >
              We believe in fusing tradition with technology. Our Marwadi jugaad
              mindset ensures we find innovative solutions to your challenges,
              delivering results that leave a mark
            </Text>
            <FlowerImage src={cream} left={"0"} bottom={"0"} />
            <FlowerImage
              src={blue}
              top={{ base: "2%", md: "0" }}
              right={{ base: "10%", md: "0" }}
            />
          </VStack>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="white"
            className="fade-in-up"
          >
              
             From{" "}
            <Text as="span" color="#BFA585" className="fade-in-up">
            small startups to established enterprises,
            </Text>
            we’ve got what it takes to put your brand in the {" "}
            <Text as="span" color="#BFA585" className="fade-in-up">
            spotlight.
            </Text>{" "}
           
          </Text>
        </Box>
      </Container>

      {/* Decorative Flower Icon */}
      <Image
        src={FlowerIcon}
        alt="Flower Icon"
        maxW={{ base: "120px", md: "190px" }}
        mx={{ base: "auto", md: "0" }}
        marginLeft={{ base: "", md: "auto" }}
        mt={6}
        className="fade-in-up"
      />

      {/* Modal for Image Popup */}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={{ base: "md", md: "xl" }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent bg="blackAlpha.800">
          <ModalBody p={4} display="flex" justifyContent="center">
            <Image src={selectedImage} alt="Popup Image" borderRadius="md" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Portfolio;
